exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".create-spec-page {\r\n  max-width: 720px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.create-spec-page__header {\r\n  padding: 24px 24px 0;\r\n}\r\n\r\n.create-spec-page__title {\r\n  margin: 0 0 24px;\r\n  font-size: 22px;\r\n  font-weight: 700;\r\n  color: var(--color-text, #212529);\r\n}\r\n\r\n.create-spec-page__body {\r\n  padding: 0 24px 24px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/admin/create-specialization-container/create-specialization-container.component.css
// module id = ../../../../../src/app/content-page/common/skill-learning/components/admin/create-specialization-container/create-specialization-container.component.css
// module chunks = main